export const APPLY_GROUP_MOVEMENT = `
  mutation applyGroupMovement($input: ApplyGroupMovementInput!, $tenant_id: Int!) {
    applyGroupMovement(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on GroupMovement {
        id
        group_id
        request_reason_id
        applied_from
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const REVERSE_GROUP_MOVEMENT = `
  mutation reverseGroupMovement($id: Int!, $tenant_id: Int!) {
    reverseGroupMovement(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on GroupMovement {
        id
        reversed
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
